import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is pending confirmation; otherwise the id of the facility to confirm. */
const facilityToDeleteSignal = createSignal<number | null>(null);

export const setFacilityToDelete = (facilityId: number | null): void => {
	facilityToDeleteSignal.value = facilityId;
};

export default facilityToDeleteSignal;
